import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { RTLProvider } from './context/RTLContext';
import LanguageSwitcher from './components/LanguageSwitcher';
import Home from './pages/Home';
import Questionnaire from './pages/Questionnaire';
import Completed from './pages/Completed';
import Survey from './pages/Survey';
import SurveyCompleted from './pages/SurveyCompleted';
import NotFound from './pages/NotFound';
import ScrollToTop from './utils/ScrollToTop';
import './App.css';

function App() {
  return (
    <RTLProvider>
      <Router>
        <ScrollToTop />
        <LanguageSwitcher />
        <div className="App">
          <div className="app-content">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/questionnaire/:sessionId" element={<Questionnaire />} />
              <Route path="/completed/:sessionId" element={<Completed />} />
              <Route path="/survey/:surveyId" element={<Survey />} />
              <Route path="/survey/:surveyId/completed" element={<SurveyCompleted />} />
              <Route path="/404" element={<NotFound />} />
              <Route path="*" element={<Navigate to="/404" replace />} />
            </Routes>
          </div>
        </div>
      </Router>
    </RTLProvider>
  );
}

export default App;